import React, { useCallback, useMemo } from "react";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import { useSelector } from "react-redux";
import { EMDR_INBOX_PAGE_TABS } from "../constant";
import $ from "jquery";
import "./index.scss";

interface IEmdrInboxDetail {
  data: any;
}
const EmdrInboxDetail: React.FC<IEmdrInboxDetail> = (props) => {
  const type = useSelector((state) => state["emdrInboxReducer"].type);
  // Ensure data and claims exist
  const claimsData = (props && props?.data?.data.claimsList) || []; // Fallback to empty array if no claims

  const emdrInboxDetail = useMemo(() => {
    return getEmdrInboxDetailGridOptions(claimsData, type, onRowPrepared);
  }, [claimsData]);

  // If no data or claims, return a message
  if (!claimsData || claimsData.length === 0) {
    return <div>No Payload Information Available.</div>;
  }
  return (
    <div className="emdr-inbox-container">
      <MdaeDataGrid {...emdrInboxDetail} />
    </div>
  );
};
const onRowPrepared = (e) => {
  if (e.rowType === "data" && !e.data.isDocumentSeen) {
    $(e.rowElement).addClass("unseen-document");
  } else {
    $(e.rowElement).addClass("seen-document");
  }
};

// Function to generate DataGrid options for the detail grid
const getEmdrInboxDetailGridOptions =(claimsData, type, onRowPrepared) => {
  const emdrInboxDetailGridOptions: IMdaeDataGridProps = {
    id:
      "pnleMDRInboxClaimDetailGrid" +
      claimsData[0]?.documentEmdrInboxAssociationId,
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    export: { enabled: true, fileName: "Inbox Claim Detail" },
    headerFilter: { visible: true },
    selection: { mode: "single" },
    dataSource: claimsData,
    filterRow: { visible: true },
    width: "100%",
    mdaeColumns: [
      {
        caption: "DocumentEmdrInboxAssociationId",
        dataField: "documentEmdrInboxAssociationId",
        width: 150,
        visible: false,
        showInColumnChooser: false,
      },
      {
        caption: "File Name",
        dataField: "originalFileName",
        width: 180,
        visible: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        showInColumnChooser: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
      },
      {
        caption: "Claim ID",
        dataField: "claimId",
        width: 150,
      },
      {
        caption: "Subscriber ID",
        dataField: "subscriberId",
        width: 180,
      },
      {
        caption: "Patient Last Name",
        dataField: "patientLastName",
        width: 180,
      },
      {
        caption: "Patient First Name",
        dataField: "patientFirstName",
        width: 180,
      },
      {
        caption: "Claim Type",
        dataField: "claimTypeDescription",
        width: 120,
      },
      {
        caption: "Service From",
        dataField: "statementFromDate",
        width: 120,
        dataType: "date",
        format: "shortDate",
      },
      {
        caption:
          claimsData[0]?.claimTypeDescription?.toLowerCase() === "professional"
            ? "Service To"
            : claimsData[0]?.claimTypeDescription?.toLowerCase() === "hospital"
            ? "Discharge Date"
            : "Service To/Discharge Date",
        dataField: "statementToDate",
        width: 120,
        dataType: "date",
        format: "shortDate",        
      },
      {
        caption: "Audit ID",
        dataField: "attachedLevelId",
        width: 120,
        visible: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        showInColumnChooser: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        cellRender: (cellData) => {
          if (cellData.data?.attachedLevelId) {
            const attachedLevelIds = cellData.data.attachedLevelId.split(",");
            return( 
              <div style={{ display: "flex", flexWrap: "nowrap" }}>
             { attachedLevelIds.map((levelId, index) => {
              const auditURLString = "/externalaudit/audit?auditId=";
              return (
                <span key={index}>
                  <a href={auditURLString + levelId} target="_blank">
                    {levelId}
                  </a>
                  {index < attachedLevelIds.length - 1 && ", "}
                </span>
              );
            })}
            </div>
          );
          } else return "N/A";
        }
      },      
      {
        caption: "Case ID",
        dataField: "eaCaseId",
        width: 120,
        visible: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        showInColumnChooser: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        cellRender: (cellData) => {
          if (cellData.data?.eaCaseId && cellData.data?.linkedEAAuditId) {
            const linkedEAAuditIds = cellData.data.linkedEAAuditId.split(",");
            const eaCaseIds = cellData.data.eaCaseId.split(",");
            
            // Ensure that both arrays have the same length before rendering
            if (linkedEAAuditIds.length === eaCaseIds.length) {
              return eaCaseIds.map((eaCaseId, index) => {
                const auditURLString = `/externalaudit/audit?auditId=${linkedEAAuditIds[index]}`;
                return (
                  <span key={index} style={{ whiteSpace: "nowrap" }}>
                    <a href={auditURLString} target="_blank" rel="noopener noreferrer">
                      {eaCaseId}
                    </a>
                    {index < eaCaseIds.length - 1 && ", "}
                  </span>
                );
              });
            }
          }
          return "N/A";
        },
      }      
    ],
    onRowPrepared: onRowPrepared,
  };
  return emdrInboxDetailGridOptions;
};

export default EmdrInboxDetail;
